export default "__VITE_ASSET__GgWGVE_e__"